import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { isAuthenticated as authServiceCheck } from '../services/authService';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    console.log('ProtectedRoute checking authentication:');
    console.log('- useAuth.isAuthenticated:', isAuthenticated);
    
    // Kiểm tra trực tiếp từ service
    const directCheck = authServiceCheck();
    console.log('- Direct auth check:', directCheck);
    
    // Kiểm tra trực tiếp localStorage
    const token = localStorage.getItem('jwt_token');
    console.log('- Token in localStorage:', token ? 'Có' : 'Không');
  }, [isAuthenticated]);

  if (!isAuthenticated) {
    console.log('Chuyển hướng đến trang đăng nhập do chưa xác thực');
    // Chuyển hướng về trang đăng nhập nếu chưa đăng nhập
    return <Navigate to="/login" replace />;
  }

  console.log('Đã xác thực, hiển thị nội dung bảo vệ');
  return <>{children}</>;
};

export default ProtectedRoute; 